import React from 'react';
import { Steps, StepsProps, Tooltip } from 'antd';
import moment from 'moment';

const ListSteps: React.FC<any> = ({ record }) => {
  const { Step } = Steps;

  const customDot: StepsProps['progressDot'] = (
    dot: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined,
    { status, index, title, description }: any
  ) => (
    <Tooltip
      title={
        <span>
          {index === 0
            ? ' Indica que o item ainda não foi enviado ou preparado para o envio.'
            : index === 1
            ? 'Indica que o pedido está em transito  para o destinatário.'
            : index === 2
            ? 'Indica que o item chegou no endereço de entrega.'
            : index === 3
            ? 'Indica que o item foi entregue com sucesso ao cliente e o processo de entrega foi concluído.'
            : ''}
        </span>
      }
    >
      {dot}
    </Tooltip>
  );

  let activeStep = 0;
  switch (record.status) {
    case 'AE':
      activeStep = 0;
      break;
    case 'ET':
      activeStep = 1;
      break;
    case 'CC':
      activeStep = 2;
      break;
    case 'EF':
      activeStep = 3;
      break;
    default:
      activeStep = -1;
      break;
  }

  return (
    <>
      <Steps className="steps" responsive={true} current={activeStep} progressDot={customDot}>
        <Step
          title="Aguardando expedição"
          subTitle={
            <span className="themeSLA">
              {record?.nfDhEmissao && moment(record?.nfDhEmissao).format('l')}
            </span>
          }
        />
        <Step
          title="Em transito"
          subTitle={
            <span className="themeSLA">
              {record?.dtSaida && moment(record?.dtSaida).format('l')}
            </span>
          }
        />
        <Step
          title="Chegada ao cliente"
          subTitle={
            <span className="themeSLA">
              {record?.dtCliente && moment(record?.dtCliente).format('l')}
            </span>
          }
        />
        <Step
          title="Entrega finalizada"
          subTitle={
            <span className="themeSLA">
              {record?.dtEntrega && moment(record?.dtEntrega).format('l')}
            </span>
          }
        />
      </Steps>
    </>
  );
};

export default ListSteps;
